<template>
  <div>
    <div class="d-flex">
      <v-select
        v-model="status_filter"
        multiple
        :items="statusItems"
        item-text="name"
        item-value="value"
        @change="getFilteredTrade"
        dense
        label="Status"
        outlined
        class="selectBox"
        background-color="#fff"
      ></v-select>
      <v-select
        v-model="buy_sell"
        multiple
        :items="buySellItems"
        dense
        label="Buy/Sell"
        @change="getFilteredTrade"
        outlined
        class="selectBox"
        background-color="#fff"
      ></v-select>

      <v-select
        v-model="duration"
        multiple
        item-text="name_to_show"
        item-value="id"
        :items="durationItems"
        @change="getFilteredTrade"
        dense
        label="Duration"
        outlined
        class="selectBox"
        background-color="#fff"
      ></v-select>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="dates"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFormattedText"
            label="Date"
            outlined
            class="selectBox"
            background-color="#fff"
            multiple
            dense
            ref="inputField"
            readonly
            append-icon="mdi-calendar-range"
            v-bind="attrs"
            v-on="on"
            clearable
            @click:clear="dates = []"
            @click:append="(menu = !menu), $refs.inputField.focus()"
          ></v-text-field>
          <!-- {{dateFormattedText}} -->
        </template>
        <v-date-picker
          v-model="dates"
          range
          no-title
          scrollable
          @input="getFilteredTrade"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
// import Axios from "@/api/BaseAxios.js";
// import helper from "@/helper/index";
export default {
  name: "DesktopFilters",
  data() {
    return {
      loading: false,
      buy_sell: [],
      buySellItems: ["Buy", "Sell"],
      //
      status_filter: [],
      statusItems: [
        { name: "Live", value: "Active" },
        { name: "Upcoming", value: "Inactive" },
        { name: "Closed", value: "Closed" },
      ],
      //   datew
      menu: false,
      date: null,
      dates: [],
      //   duration
      durationItems: [
        {
          name: "Intra-day/BTST (1~2 days)",
          id: 1,
          name_to_show: "Intra-day",
        },
        {
          name: "Short term (1~2 weeks)",
          id: 2,
          name_to_show: "Short term",
        },
        {
          name: "Swing (2~6 weeks)",
          id: 3,
          name_to_show: "Swing",
        },
        {
          name: "Long term (>6 weeks)",
          id: 4,
          name_to_show: "Long term",
        },
      ],
      duration: [],
    };
  },
  computed: {
    dateFormattedText: {
      get() {
        if (this.dates.length) {
          if (this.dates.length == 1) {
            return this.moment(this.dates[0]).format("MMM-DD");
          } else {
            return `${this.moment(this.dates[0]).format(
              "MMM-DD"
            )},${this.moment(this.dates[1]).format("MMM-DD")}`;
          }
        } else {
          return "";
        }
      },
    },
  },
  mounted() {
    // this.getDurationList();
  },
  methods: {
    getFilteredTrade() {
      this.getTrade();
    },

    getDurationList() {
      const onSuccess = (res) => {
        var tempList = [];
        for (const obj of res.data) {
          if (obj.name_to_show !== "Short term") {
            tempList.push(obj);
          }
        }

        this.durationItems = tempList;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GET_DURATION_LIST, {
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },

    getTrade() {
      let filter = {};
      if (this.duration.length) {
        filter["duration"] = this.duration;
      }
      if (this.buy_sell.length) {
        filter["buy_sell"] = this.buy_sell;
      }
      if (this.dates.length) {
        filter["dates"] = this.dates;
      }
      if (this.status_filter.length) {
        filter["status"] = this.status_filter;
      }
      //   if (Object.keys(filter).length !== 0) {
      //     formData["filters"] = filter;
      //   }
      this.eventBus.$emit("filters", filter);
    },
  },
};
</script>

<style lang="scss" scoped>
.selectBox {
  margin: 10px 10px 0px 0px;
  height: 40px !important;
  border-radius: 8px !important;
  max-width: 140px !important;
}
</style>
